"use client";

import React from "react";
import { Landmark, Globe, ShieldCheck, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const advantages = [{
  title: "Academic Excellence",
  description: "Strategic guidance for Ivy League and Russell Group admissions, tailored to your unique academic profile and ambitious career aspirations.",
  icon: Landmark,
  link: "/ServicesPage"
}, {
  title: "Global Destinations",
  description: "Unparalleled access to premier institutions across the UK, USA, and Canada, bridging the gap between local talent and international success.",
  icon: Globe,
  link: "/DestinationsPage"
}, {
  title: "Visa & Integrity",
  description: "Transparent, end-to-end support for visa processing and scholarship procurement with a focus on absolute compliance and institutional success.",
  icon: ShieldCheck,
  link: "/ServicesPage"
}];
export default function TheCgkAdvantage() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="36135" id="the-briviox-advantage" ref={ref} className={cn("bg-muted text-foreground py-24 lg:py-32 px-4 relative overflow-hidden transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-secondary/20 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-secondary/20 to-transparent" />

      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-5xl font-default tracking-tight text-primary mb-4">
            The Briviox Advantage
          </h2>
          <div className="h-0.5 w-24 bg-secondary mx-auto" />
          <p className="mt-6 text-muted-foreground max-w-2xl mx-auto text-lg font-default font-light">
            Where Ambition Meets Achievement through institutional prestige, academic rigor, and global reach.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {advantages.map((item, i) => {
          const Icon = item.icon;
          return <div key={i} data-index={i} className={cn("group relative transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="h-full bg-card border-border transition-all duration-500 group-hover:-translate-y-2.5 group-hover:border-secondary/30 group-hover:shadow-xl overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-b from-secondary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  
                  <CardHeader className="relative z-10 pt-10 pb-2">
                    <div className="mb-6 inline-flex items-center justify-center w-16 h-16 rounded-full border border-secondary/20 bg-secondary/5 text-secondary group-hover:bg-secondary/10 group-hover:border-secondary/40 transition-colors duration-500">
                      <Icon strokeWidth={1.5} className="w-12 h-12" />
                    </div>
                    <CardTitle className="text-xl uppercase tracking-widest font-default font-semibold text-primary group-hover:text-secondary transition-colors duration-300">
                      {item.title}
                    </CardTitle>
                  </CardHeader>
                  
                  <CardContent className="relative z-10 pb-10">
                    <CardDescription className="text-base leading-relaxed text-muted-foreground font-default mb-8 group-hover:text-foreground transition-colors duration-300">
                      {item.description}
                    </CardDescription>
                    
                    <div className="absolute bottom-8 left-6 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 ease-out">
                      <Link to={item.link} className="inline-flex items-center text-sm font-default font-medium text-secondary hover:text-secondary/80 tracking-wide uppercase">
                        Explore Service
                        <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                      </Link>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}